import { render, staticRenderFns } from "./CardSlot.vue?vue&type=template&id=1548338c&scoped=true"
import script from "./CardSlot.vue?vue&type=script&lang=js"
export * from "./CardSlot.vue?vue&type=script&lang=js"
import style0 from "./CardSlot.vue?vue&type=style&index=0&id=1548338c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1548338c",
  null
  
)

export default component.exports